import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import App from './App';
import { store, persistor } from './app/store';
import './index.css';
import { AdvancesProvider } from '../src/Context/AdvancesContext';
// Import your AdvancesProvider here:
const rootElement = document.getElementById('root');

const renderApp = () => {
	ReactDOM.createRoot(rootElement).render(
		<Provider store={store}>
			<PersistGate loading={null} persistor={persistor}>
				<AdvancesProvider>
					<App />
				</AdvancesProvider>
			</PersistGate>
		</Provider>
	);
};

// Check if the createRoot method is available
if (rootElement.createReactRoot) {
	rootElement.createReactRoot();
}

// Render the app
renderApp();
